import { Router } from "@angular/router";

export function setStorageBackRoute(router: Router, routerLink: string | string[]) {
  const tree = router.parseUrl(Array.isArray(routerLink) ? routerLink[0] : routerLink);
  const cleanUrl = tree.root.children['primary']?.segments.map(it => it.path).join('/') || '';
  localStorage.setItem(cleanUrl, router.url);
}
